import qs from 'qs';
import { useCallback } from 'react';
import { useLocation } from 'react-router';

export const usePreserveQueries = () => {
  const location = useLocation();

  const preserveQueries = useCallback(
    (queriesToUpdate: Record<string, string>) => {
      const existingQueries = qs.parse(location.search, {
        ignoreQueryPrefix: true,
      });

      return qs.stringify({ ...existingQueries, ...queriesToUpdate }, { skipNulls: true });
    },
    [location],
  );

  return preserveQueries;
};
